import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import isBoolean from 'lodash/isBoolean';
import isObject from 'lodash/isObject';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands } from '../constant';
export var NsUpdateEdge;
(function (NsUpdateEdge) {
    NsUpdateEdge.command = XFlowEdgeCommands.UPDATE_EDGE;
    NsUpdateEdge.hookKey = 'updateEdge';
    NsUpdateEdge.XFlowEdgeSetOptions = { overwrite: true };
    NsUpdateEdge.XFlowUpdateLabelService = (edge, edgeConfig, options = NsUpdateEdge.XFlowEdgeSetOptions) => __awaiter(this, void 0, void 0, function* () {
        edge === null || edge === void 0 ? void 0 : edge.setLabelAt(0, (edgeConfig === null || edgeConfig === void 0 ? void 0 : edgeConfig.label) || edgeConfig, options);
    });
})(NsUpdateEdge || (NsUpdateEdge = {}));
let UpdateEdgeCommand = class UpdateEdgeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.updateEdge.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { updateEdgeService, updateEdgeLabelService = NsUpdateEdge.XFlowUpdateLabelService, options = NsUpdateEdge.XFlowEdgeSetOptions, } = handlerArgs;
                const edgeConfig = updateEdgeService
                    ? yield updateEdgeService(handlerArgs)
                    : handlerArgs === null || handlerArgs === void 0 ? void 0 : handlerArgs.edgeConfig;
                const x6Edge = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(edgeConfig === null || edgeConfig === void 0 ? void 0 : edgeConfig.id);
                x6Edge === null || x6Edge === void 0 ? void 0 : x6Edge.setData(edgeConfig, options);
                if (edgeConfig === null || edgeConfig === void 0 ? void 0 : edgeConfig.hasOwnProperty('label')) {
                    // 默认更新edge的第一个label
                    yield updateEdgeLabelService(x6Edge, edgeConfig, options);
                }
                if (isBoolean(edgeConfig === null || edgeConfig === void 0 ? void 0 : edgeConfig.visible)) {
                    x6Edge.setVisible(edgeConfig === null || edgeConfig === void 0 ? void 0 : edgeConfig.visible);
                }
                if (edgeConfig.attrs) {
                    x6Edge.setAttrs(edgeConfig.attrs);
                }
                if (edgeConfig.vertices) {
                    x6Edge.setVertices(edgeConfig.vertices);
                }
                if (edgeConfig.router) {
                    x6Edge.setRouter(edgeConfig.router);
                }
                if (edgeConfig.connector) {
                    x6Edge.setConnector(edgeConfig.connector);
                }
                if (isObject(edgeConfig.source)) {
                    //@ts-ignore
                    x6Edge.setSource(edgeConfig.source);
                }
                if (isObject(edgeConfig.target)) {
                    //@ts-ignore
                    x6Edge.setTarget(edgeConfig.target);
                }
                return {
                    edgeConfig,
                    edgeCell: x6Edge,
                };
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], UpdateEdgeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UpdateEdgeCommand.prototype, "init", null);
UpdateEdgeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsUpdateEdge.command.id },
    })
    /** 连线更新命令 */
], UpdateEdgeCommand);
export { UpdateEdgeCommand };
//# sourceMappingURL=edge-update.js.map